import { css } from 'emotion'

export const bold = css`
	font-size: 1.38rem;
	font-weight: 700;
`
